<template>
  <div class="card-block">
    <div class="form-group row">
      <div class="col-md-10">
        <h5>
          <strong
            ><i class="fas fa-store"></i> {{ $t('associates.iap') }}</strong
          >
        </h5>
      </div>
      <div class="col-md-2" v-if="hideEye">
        <a
          v-if="!isBusyInfosFinance"
          href="javascript:void(0);"
          @click="isBusyInfosFinance = !isBusyInfosFinance"
        >
          <i
            class="fas fa-eye"
            style="font-size: 16px"
            v-b-tooltip.hover
            :title="'Minimizar Dados'"
          ></i>
        </a>
        <a v-else href="javascript:void(0);" @click="onLoadFinanceResume">
          <i
            class="fas fa-eye-slash"
            style="font-size: 16px"
            v-b-tooltip.hover
            :title="'Mostrar Dados'"
          ></i>
        </a>
      </div>
    </div>

    <b-card
      v-if="isBusyInfosFinance && utilizacaoProdutos"
      :footer="
        utilizacaoProdutos.anoMesMovimento
          ? 'Referência: ' + utilizacaoProdutos.anoMesMovimento
          : ''
      "
      no-body
    >
      <b-tabs id="tabsProdutos" bg-variant="dark" fill>
        <b-tab title="Todos" active>
          <div class="card-body">
            <h5>{{ produtos.length }} Produtos</h5>
            <hr />
            <ul class="list-unstyled d-flex flex-wrap" style="gap: .5rem">
              <li
                v-for="([key, value], index) in produtos"
                :key="index"
                class="listItem"
              >
                <i :class="getIconClass(value)"></i>
                {{ getNameFromEnum(key) }}
              </li>
            </ul>
          </div>
        </b-tab>

        <b-tab title="Ativos">
          <div class="card-body">
            <h5>{{ ativos.length }} Ativos</h5>
            <hr />
            <ul class="list-unstyled d-flex flex-wrap" style="gap: .5rem">
              <li
                v-for="([key, value], index) in ativos"
                :key="index"
                class="listItem"
              >
                <i :class="getIconClass(value)"></i>
                {{ getNameFromEnum(key) }}
              </li>
            </ul>
          </div>
        </b-tab>

        <b-tab title="Inativos">
          <div class="card-body">
            <h5>{{ inativos.length }} Inativos</h5>
            <hr />
            <ul class="list-unstyled d-flex flex-wrap" style="gap: .5rem">
              <li
                v-for="([key, value], index) in inativos"
                :key="index"
                class="listItem"
              >
                <i :class="getIconClass(value)"></i>
                {{ getNameFromEnum(key) }}
              </li>
            </ul>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'AssociateUtilizacaoProdutos',
  props: {
    utilizacaoProdutos: Object,
    isBusyInfosFinance: {
      type: Boolean,
      default: false
    },
    hideEye: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    produtos () {
      return Object.entries(this.utilizacaoProdutos[0] || {}).filter(
        ([key, value]) => value === 'SIM' || value === 'NÃO'
      )
    },
    ativos () {
      return this.produtos.filter(([key, value]) => value === 'SIM')
    },
    inativos () {
      return this.produtos.filter(([key, value]) => value === 'NÃO')
    }
  },

  methods: {
    getIconClass (value) {
      return value === 'SIM'
        ? 'fas fa-check text-success'
        : 'fas fa-times text-danger'
    },
    getNameFromEnum (key) {
      const labels = {
        utilizacaoCartooDebito: 'Cartão Débito',
        utilizacaoCartaoCredito: 'Cartão Crédito',
        utilizacaoPrevidencia: 'Previdência',
        indicadorUtilizacaoSipag: 'Sipag',
        debitoAutomaticoEfetivado: 'Débito Automatico Efetivado',
        produtoRdc: 'RDC',
        produtoChequeEspecialContaGarantida: 'Cheque Especial Conta Garantida',
        produtoContaGarantida: 'Conta Garantida',
        produtoChequeEspecial: 'Cheque Especial',
        produtoCobranca: 'Cobrança',
        produtoConsorcioAutomovel: 'Consórcio Automóvel',
        produtoConsorcioImovel: 'Consórcio Imóvel',
        produtoConsorcioMoto: 'Consórcio Moto',
        produtoConsorcioServicos: 'Consórcio Serviços',
        produtoPreAprovado: 'Pré-Aprovado',
        produtoCreditoRural: 'Crédito Rural',
        produtoEmprestimo: 'Empréstimo',
        produtoFinanciamento: 'Financiamento',
        produtoPoupanca: 'Poupança',
        produtoSeguroRural: 'Seguro Rural',
        produtoSeguroAuto: 'Seguro Auto',
        produtoVidaPrestamista: 'Vida Prestamista',
        produtoSeguroVidaPfPj: 'Seguro Vida PF/PJ',
        produtoSeguroMassificados: 'Seguro Massificados',
        produtoTituloDescontado: 'Título Descontado',
        indicadorProdutoCambio: 'Câmbio',
        indicadorProdutoConsorcioBensMoveis: 'Consórcio Bens Móveis',
        indicadorProdutoConsorcioPesado: 'Consórcio Pesado',
        indicadorProdutoCoopcerto: 'Coopcerto',
        indicadorProdutoLCI: 'LCI',
        indicadorProdutoLCA: 'LCA',
        indicadorProdutoVGBL: 'VGBL',
        indicadorProdutoPix: 'Pix',
        indicadorProdutoTag: 'Tag',
        indicadorProdutoSeguroPatrimonial: 'Seguro Patrimonial',
        indicadorProdutoSeguroRiscoFinanceiro: 'Seguro Risco Financeiro',
        indicadorProdutoFundoInvestimento: 'Fundo de Investimento'
      }
      return labels[key] || key
    },
    onLoadFinanceResume () {
      this.isBusyInfosFinance = !this.isBusyInfosFinance
    }
  }
}
</script>

<style scoped>
  .listItem {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/associate/components/AssociateUtilizacaoProdutos.vue